import React from "react";

const ERPBadgeList = ({ value }) => {
  if (!value) return null;

  // Normalize to array
  const items = Array.isArray(value) ? value : [value];

  return (
    <div className="flex flex-wrap gap-1">
      {items.map((item, index) => (
        <span
          key={index}
          className="inline-flex items-center rounded-md bg-green-600/10 px-2 py-0.5 text-xs font-medium text-green-600 ring-1 ring-inset ring-green-600/10"
        >
          CO-{item}
        </span>
      ))}
    </div>
  );
};

export default ERPBadgeList;
